<template>
  <div class="news">
    <div class="main">
      <div class="titbox">
        <h3>资讯动态</h3>
        <!-- <p>关注Handle新闻动态，了解MPA中国最新动向</p> -->
      </div>
      <div class="companynew clearfix">
        <div class="newsListOne">
            <el-carousel class="leftBox" ref="carousel"  @click.native="linkTo">
              <el-carousel-item v-for="item in imgArray" :key="item" number="4000">
                <div class="img">
                  <img :src="item.url" alt="">
                  <h3>{{ item.title }}</h3>
                </div>
              </el-carousel-item>
            </el-carousel>
        </div>
      <!-- <div class="companynew clearfix">
        <div class="newsListOne" v-if="comNewlist.length" @click="toDetails(comNewlist[0].type_id, comNewlist[0].con_id)">
          <div class="img"><img :src="comNewlist[0].image" alt=""></div>
          <div class="content">
            <h3>{{comNewlist[0].title}}</h3>
            <p class="time">{{comNewlist[0].pubdate}}</p>
            <p>{{comNewlist[0].synopsis}}...</p>
          </div>
        </div> -->
        <div class="newsListTwo" v-for="item of comNewlist" :key="item.con_id" @click="toDetails(item.type_id, item.con_id)">
          <div class="list">
            <div class="img"><img :src="item.image" alt=""></div>
            <div class="listText">
              <h3>{{item.title}}</h3>
              <p class="time">{{item.pubdate}}</p>
              <p>{{item.synopsis}}...</p>
            </div>
          </div>
        </div>
      </div>
      <router-link :to="{name:'zh-newsList', query: { currentPage: '1',  pageSize: '10'}}" class="more">查看更多>></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  data () {
    return {
      comNewlist: [],
      policyList: [],
      imgArray: [
        {
          url: require('./../../../src/assets/img/products/data/zx1.jpg'),
          title: '中国专家镇锡惠当选数联网全球管理机构副主席',
          link: 'https://www.mpacn.net/newsDetails?type_id=No_174585393ce5885&con_id=ZH_19816894daa5347'
        },
        {
          url: require('./../../../src/assets/img/products/data/news1.jpg'),
          title: '聚焦共建共享共治全球数据基础设施 数联网高峰论坛在京成功举办',
          link: 'https://www.mpacn.net/newsDetails?type_id=No_174585393ce5885&con_id=ZH_1936bca01057568'
        },
        {
          url: require('./../../../src/assets/img/products/data/xb.jpg'),
          title: '2025—DOA全球根节点管理机构协调会议在日内瓦举行，聚焦系统演进、互操作与标准化',
          link: 'https://www.mpacn.net/newsDetails?type_id=No_174585393ce5885&con_id=ZH_1981c7f06bb0129'
        }
      ]
    }
  },
  mounted () {
    this.getNewsList(1, 3)
  },
  methods: {
    getNewsList (currentPage, pageSize) {
      this.$axios.get('/v1/content/list', {
        params: {
          currentPage,
          pageSize
        }
      }).then(this.getHomeInfoSucc)
    },
    getHomeInfoSucc (res) {
      if (res.status === 200) {
        this.comNewlist = res.data.data
      }
      console.log(this.comNewlist)
    },

    // 新闻详情
    toDetails (TYPE_ID, CON_ID) {
      this.$router.push({
        name: 'zh-newsDetails',
        query: {
          type_id: TYPE_ID,
          con_id: CON_ID
        }
      })
    },

    linkTo () {
      let activeIndex = this.$refs.carousel.activeIndex
      window.open(this.imgArray[activeIndex].link, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.news{
    width:100%;
    // background-color: #f9f9f9;
    .main {
      width: 1200px;
      margin: auto;
      padding-bottom: 70px;
      .titbox{
        width: 100%;
        text-align: center;
        color:#333;
        padding:60px 0;
        h3{
            font-size: 36px;
            line-height: 1.3;
        }
        p{
            font-size: 16px;
            color:#666;
            margin-top:15px
        }
      }
      .companynew {
        width:100%;
        overflow: hidden;
        height:0;
        padding-bottom:482px;
        margin-top:30px;
        .newsListOne{
          width: 700px;
          height: 435px;
          float: left;
          .leftBox /deep/ .el-carousel__container{
            height: 435px;
            border-radius: 20px;
            overflow: hidden;
            background: #020629;
          }
          .el-carousel__item h3 {
            line-height: 20px;
            font-weight: normal;
            font-size: 18px;
            margin-top: -60px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            color:#fff;
            padding-left: 32px;
          }
          .el-carousel__item:nth-child(2n) {
            background-color: #99a9bf;
          }
          .el-carousel__item:nth-child(2n+1) {
            background-color: #d3dce6;
          }
          .img{
            width:100%;
            height:435px;
            img{
              width:100%;
              height:100%;
              object-fit: cover;
            }
          }
          .content{
            width: 100%;
            height: calc(100% - 300px);
            border: 1px solid #cbcbcb;
            padding: 16px 20px;
            h3{
              line-height: 20px;
              font-weight: normal;
              font-size: 16px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              color:#262626
            }
            p{
              line-height: 20px;
              color:#808080;
              margin: 8px 0;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
        .newsListTwo{
          width: calc(100% - 740px);
          float: left;
          margin-left: 20px;
          .list{
            width: 100%;
            margin: 12px 0;
            overflow: hidden;
            position: relative;
            border-radius: 18px;
            .img{
              width:127px;
              height:137px;
              position: absolute;
              top: 0;
              left: 0;
              img{
                width:100%;
                height:100%;
                object-fit:cover
              }
            }
            .listText{
              float: left;
              width: calc(100% - 100px);
              padding: 10px 15px 11px 40px;
              margin-left: 100px;
              h3{
                font-weight: normal;
                font-size: 16px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                color:#262626
              }
              p{
                margin:8px 0;
                line-height: 20px;
                color:#808080;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
          }
          div.list:first-child{
            margin-top: 0;
          }
        }
        .newsListOne .content,
        .newsListTwo .list .listText{
          transition: all .3s ease-out;
        }
        .newsListOne, .newsListTwo .list{
          cursor: pointer;
          box-shadow: 0 3px 12px #f2f2f2;
        }
        .newsListOne:hover .content, .newsListTwo .list:hover .listText{
          background: #2f8bdb;
        }
        .newsListOne:hover .content .time:after, .newsListTwo .list:hover .listText .time:after{
          width: 100%;
          background: #fff;
        }
        .newsListOne:hover .content h3,
        .newsListOne:hover .content p,
        .newsListTwo .list:hover .listText h3,
        .newsListTwo .list:hover .listText p{
          color: #fff;
        }
        .newsListOne .content .time,.newsListTwo .list .listText .time{
          position: relative;
        }
        .newsListOne .content .time:after,.newsListTwo .list .listText .time:after{
          content:'';
          display: block;
          position: absolute;
          left: 0;
          bottom: 0;
          width:20px;
          height: 1px;
          background: #c7c7c7;
          transition: all .3s ease-out;
        }
      }
      .more{
        display: block;
        color: #0065dd;
        font-size: 16px;
        text-align: center;
      }
    }
}
@media screen and (max-width:1000px) {
  .news{
    .main {
      width:100%;
      .companynew {
        width:100%;
        height:auto;
        padding-bottom:0;
        .newsListOne{
          width: 100%;
          height: 470px;
          float: none;
        }
        .newsListTwo{
          width: 100%;
          float: none;
          margin-top: 15px;
          margin-left:0
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/Home/components/news.vue